<!--@format-->
<template>
    <div class="denied-partnership-details-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>{{ isLoading ? 'Loading...' : 'Details' }}</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <div v-if="isLoading">
                    <loading-screen-svg />
                </div>
                <div v-else class="widget-container">
                    {{ agencyName }} has denied your request for the following reason:
                    <div class="reason-container">
                        {{ agencyReason }}
                    </div>
                    You may <a :href="redirect">submit another request</a> at anytime.
                </div>
            </div>
            <div class=" widget-footer">
                <div v-if="!isLoading" class="action-container">
                    <app-button class="close-btn" @click="onClickClose">
                        Close
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');
import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'denied-partnership-details-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'loading-screen-svg': LoadingScreenSvg,
    },

    provide() {
        return {
        };
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            isLoading: false,
            agencyName: this.widget.agencyName,
            agencyReason: this.widget.agencyReason,
            agencyId: this.widget.agencyId,
        };
    },

    computed: {
        baseUrl(){
            return this.$store.getters.routeBaseUrl;
        },

        redirect() {
            return `${this.baseUrl}/Marketplace/${this.agencyId}`
        }
    },

    methods: {

        closeWidget() {
            EventBus.$emit('close-widget', this.widget, this.widget.clientId);
        },

        onClickClose() {
            this.closeWidget()
        }
    },
};
</script>

<style>
.denied-partnership-details-widget {
    text-align: left;
    font: normal normal normal 16px/24px Roboto;
    letter-spacing: 0px;
    color: #382153;
}

.denied-partnership-details-widget .action-container {
    width: 100%;
    display: inline-flex;
    justify-content: flex-end;
}

.denied-partnership-details-widget .reason-container {
    text-align: left;
    font: normal normal bold 16px/24px Roboto;
    letter-spacing: 0px;
    color: #382153;
    padding: 20px 0;
}

.denied-partnership-details-widget a {
    text-align: left;
    font: normal normal bold 16px/24px Roboto;
    letter-spacing: 0px;
    color: #18AEFF;
}
</style>
